<template>
  <div>
    <v-layout class="p-4 border-bottom-light-grey min-height-57px">
      <v-flex md5 class="font-level-3-bold my-auto">
        <span class="detail-svg-icon mr-2">
          <!--begin::Svg Icon-->
          <inline-svg
            :src="$assetURL('media/custom-svg/reservation-color.svg')"
          />
          <!--end::Svg Icon-->
        </span>
        <!-- {{ getTitle() }} -->
      </v-flex>
    </v-layout>
    <template v-if="contentLoading">
      <!-- <Loading /> -->
    </template>
    <div v-else class="overflow-y">
      <table width="100%" class="detail-table table-head-sticky">
        <thead>
          <tr>
            <!-- <th width="30" class="p-2 blue lighten-4 text-center"></th> -->
            <th width="60" class="p-2 blue lighten-4 text-center">#</th>
            <th width="60" class="p-2 blue lighten-4">Image</th>
            <th width="250" class="p-2 blue lighten-4">Item</th>
            <th width="120" class="p-2 blue lighten-4">UOM</th>
            <th width="120" class="p-2 blue lighten-4 text-center">Qty</th>
            <th width="150" class="p-2 blue lighten-4 text-center">Rate</th>
            <th width="160" class="p-2 blue lighten-4 text-right pr-5">
              Amount
            </th>
          </tr>
        </thead>
        <!-- <tbody v-if="line_items.length"> -->
        <template v-if="line_items.length">
          <tr>
            <!-- <td class="p-2 border-top-light-grey"></td> -->
            <td class="p-2 border-top-light-grey"></td>
            <td colspan="2" class="p-2 border-top-light-grey">
              <!-- <ShowValue :object="line_items_detail" object-key="free_text" label="free text"></ShowValue> -->
            </td>
            <td class="p-2 border-top-light-grey" valign="top">
              <!-- <ShowValue v-if="false" :object="line_items_detail" object-key="uom" label="uom"></ShowValue> -->
            </td>
            <td colspan="3" class="p-2 border-top-light-grey"></td>
          </tr>
      

          <tr
            v-for="(row, index) in line_items"
            :key="index"
            @click="goToPage(row.type, row.product_id)"
          >

            <td class="p-2 border-top-light-grey text-center">
              {{
                row.type != "header"/*  && row.type != "other" */ && row.counting_item
                  ? row.counting_item + "."
                  : ""
              }}
            </td>
            <td class="p-2 border-top-light-grey text-center">
              <v-avatar
                size="40"
                v-if="row.type != 'header'"
              >
                <img
                  v-if="row?.image?.url"
                  :src="row?.image?.url"
                  :alt="row?.image?.name"
                />
                <img v-else :src="$defaultImage" />
              </v-avatar>
              <v-chip color="blue" label class="ml-2 white--text" small v-else>
                <span class="font-size-16 font-weight-500">
                  {{ row.type == "header" ? "Header" : "Other" }}
                </span>
              </v-chip>
            </td>
            <!--:colspan="row.type=='header' || row.type=='other' ? 4:1"-->
            <td class="p-2 border-top-light-grey">
              <template v-if="row.product">
                <span class="font-weight-500">{{ row.product }} </span>
                <v-chip
                  color="blue"
                  label
                  class="ml-2 white--text"
                  small
                  v-if="row.type != 'header' && row.type == 'equipment' &&  row.original_equipment?.owner_ref"
                >
                  <span class="font-size-16 font-weight-500 text-uppercase">
                    {{ row.original_equipment?.owner_ref }}
                   
                  </span>
                </v-chip>
                  <v-chip
                    color="blue"
                    label
                    class="ml-2 white--text"
                    small
                    v-if="row.type != 'header' && row.type == 'product' && row.original_product?.serial_number"
                  >
                    <span class="font-size-16 font-weight-500">
                      <template v-if="row.type == 'product'">
                      {{ row.original_product?.serial_number }}
                    </template>
                    </span>
                  </v-chip>

                   <v-chip
                      v-if="row.product_type != 'header'"
                      color="cyan white--text"
                      label
                      class="lip-type text-uppercase font-weight-600 ml-2"
                      :class="{
                        product: row.product_type == 'door',
                        service: row.product_type == 'service',
                        equipment: row.product_type == 'parts',
                        other: row.product_type == 'other',
                        'btx-header': row.product_type == 'header',
                      }"
                    >
                      {{ row.type == "product" ? "Spare part" : row.type }}
                    </v-chip>
                  
              </template>
              <em v-else class="text-muted"> no item name </em>
              <div style="font-size: 12px" class="custom-nowrap-ellipsis-count">
                {{ row.description }}
              </div>
              <!-- <ShowValue :object="row" object-key="product_name" label="product"></ShowValue> -->
            </td>

            <td class="p-2 border-top-light-grey">
              <template v-if="row.uom">
                {{ row.type != "header"  ? row.uom : "" }}
              </template>
              <!-- <em v-else class="text-muted"> no uom </em> -->
              <!-- <ShowValue :object="row" object-key="uom" label="uom"></ShowValue> -->
            </td>
            <td class="p-2 border-top-light-grey text-center">
              {{
                row.type != "header" 
                  ? row.quantity
                    ? row.quantity
                    : 0
                  : ""
              }}
            </td>
            <td class="p-2 border-top-light-grey text-center">
              <template
                v-if="row.is_price_changed && line_items_detail.show_price"
              >
                <v-icon color="red" size="12">mdi-circle</v-icon>
                ({{ row.sprice ? `$${row.sprice}` : "$0" }})
              </template>
              <template v-if="row.rate">
                {{
                  row.type != "header" 
                    ? formatMoney(row.rate ? row.rate : 0)
                    : ""
                }}
              </template>
            </td>
            <td class="p-2 border-top-light-grey text-right pr-5">
              <template v-if="row.total">
                {{
                  row.type != "header" 
                    ? formatMoney(row.total ? row.total : 0)
                    : ""
                }}
              </template>
            </td>
          </tr>
          <!-- </Draggable> -->
          <tfoot style="font-size: 14px">
            <tr style="font-size: 1.2rem">
              <td colspan="6" class="p-2 text-right"><b>Sub Total</b></td>
              <td class="p-2 text-right pr-5">
                <b>{{ formatMoney(line_items_detail.sub_total) }}</b>
              </td>
            </tr>
            <tr v-if="line_items_detail.discount_value_type">
              <td colspan="6" class="p-2 text-right">
                <b
                  >Discount ({{
                    line_items_detail.discount_value_type == 1 ? "$" : ""
                  }}{{ line_items_detail.discount_value
                  }}{{
                    line_items_detail.discount_value_type == 2 ? "%" : ""
                  }})</b
                >
              </td>
              <td class="p-2 text-right pr-5">
                <b> {{ formatMoney(line_items_detail.discount_amount) }}</b>
              </td>
            </tr>

            <tr v-if="line_items_detail.ctx_discount">
              <!-- <td colspan="6" class="p-2 text-right">
								<b>{{ line_items_detail.ctx_discount_label }}</b
								>
							</td> -->
              <td class="p-2 text-right" colspan="6">
                <b
                  >{{ line_items_detail.ctx_discount_label }} ({{
                    line_items_detail.ctx_discount_type == 1 ? "$" : ""
                  }}{{ line_items_detail.ctx_discount_value
                  }}{{
                    line_items_detail.ctx_discount_type == 2 ? "%" : ""
                  }})</b
                >
              </td>
              <td class="p-2 text-right pr-5">
                <b> {{ formatMoney(line_items_detail.ctx_discount) }}</b>
              </td>
            </tr>

            <tr v-if="line_items_detail.tax_applied">
              <td colspan="6" class="p-2 text-right">
                <b>Tax {{ line_items_detail.tax_value }}%</b>
              </td>
              <td class="p-2 text-right pr-5">
                <b>{{ formatMoney(line_items_detail.tax_amount) }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="6" class="p-2 text-right"><b>Adjustment</b></td>
              <td class="p-2 text-right pr-5">
                <b>{{ formatMoney(line_items_detail.adjustment) }}</b>
              </td>
            </tr>
            <tr style="font-size: 1.5rem">
              <td colspan="6" class="p-2 text-right green--text">
                <b>Grand Total</b>
              </td>
              <td class="p-2 text-right green--text pr-5">
                <b>{{ formatMoney(line_items_detail.total) }}</b>
              </td>
            </tr>
          </tfoot>
        </template>
        <!-- </tbody> -->
        <tfoot v-else>
          <tr>
            <td colspan="6">
              <p class="m-0 row-not-found text-center py-3">
                <img
                  :src="$assetURL('media/error/empty.png')"
                  class="row-not-found-image"
                />
                Uhh... There
                <span class="text-lowercase"
                  >are no {{ getTitle() }} at the moment.</span
                >
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>

import { GET } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
export default {
  mixins: [CommonMixin],
  props: {
    type: {
      type: String,
      default: null,
    },
    typeText: {
      type: String,
      default: null,
    },
    itemType: {
      type: String,
      default: null,
    },
    uuid: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: "all",
    },
  },
  data() {
    return {
      counter: 0,
      customCounting: 0,
      contentLoading: false,
      line_items: [],
      line_items_detail: {
        total: 0,
        sub_total: 0,
        tax_type: 1,
        discount_type: 2,
        discount_value_type: 2,
        total_items: null,
        discount_value: 0,
        discount_amount: 0,
        tax_value: 7,
        taxable_amount: 0,
        tax_amount: 0,
        adjustment: 0,
        tax_applied: 0,
        gst: 0,
      },
      pageLoading: true,
    };
  },
  methods: {
    
    goToPage(type, productId = 0) {
      if (productId == 0) {
        return false;
      }
      if (type == "equipment") {
        this.$router.push(
          this.getDefaultRoute("equipment.detail", {
            params: { id: productId },
          })
        );
      
      }
      if (type == "product") {
        this.$router.push(
          this.getDefaultRoute("product.detail", {
            params: { id: productId },
          })
        );
        
      }
    },
    getTitle() {
      return "Equipments/Spare parts";
    },
    async getQuotationLineItems() {
     
      this.contentLoading = true;

      this.$store
        .dispatch(GET, {
          url:
            "line-items-sell-rental/?type_id=" + this.id + "&type=" + this.type,
        })
        .then(({ data }) => {
          this.contentLoading = false;
          this.line_items_detail = data.detail;
          this.line_items = data.line_items;
          this.counter = 0;
         
        })
        .catch((error) => {
          this.logError(error);
        });
    },
   
  },
  components: {
   
  },
  
  mounted() {
    if (this.id) {
      this.counter = 0;
      this.getQuotationLineItems(this.id);
    }
  },
};
</script>
<style>
.custom-nowrap-ellipsis-count {
  display: block !important;
  -webkit-font-smoothing: antialiased;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
